import React from 'react';
import { logRender } from '@onevision-resources/utils';
import { AfRoot } from '../af-root';

export const AfAppView: React.FC = () => {
  logRender(AfAppView);

  return <AfRoot />;
};
